import React, { useEffect, useState } from 'react';
import { Home, MessageSquare, Users, UserCheck, BookCopy, Megaphone, BarChart, Menu, X, LogOut } from 'lucide-react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
// Yönetici Paneli için Menü Elemanları
const menuItemsAdmin = [{
  icon: Home,
  label: 'Anasayfa',
  path: '/yonetici'
}, {
  icon: MessageSquare,
  label: 'Mesajlarım',
  path: '/yonetici/mesajlar',
  alert: true
}, {
  icon: Users,
  label: 'Öğrenci Yönetimi',
  path: '/yonetici/ogrenciler'
}, {
  icon: UserCheck,
  label: 'Öğretmen Yönetimi',
  path: '/yonetici/ogretmenler'
}, {
  icon: BookCopy,
  label: 'Sınıf Yönetimi',
  path: '/yonetici/siniflar'
}, {
  icon: Megaphone,
  label: 'Duyuru Yönetimi',
  path: '/yonetici/duyurular'
}, {
  icon: BarChart,
  label: 'Raporlar ve Analizler',
  path: '/yonetici/raporlar'
}, {
  icon: MessageSquare,
  label: 'Forum',
  path: '/yonetici/forum'
}];
// Navigasyon linki bileşeni
const NavItem = ({
  icon: Icon,
  label,
  path,
  alert
}) => {
  const location = useLocation();
  const isActive = location.pathname === path;
  return <Link to={path} className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-colors relative
        ${isActive ? 'text-white bg-white/10 border border-purple-500 border-opacity-50' : 'text-gray-400 hover:text-white hover:bg-white/5'}`} data-id="element-172">
      <Icon className="w-5 h-5 shrink-0" data-id="element-173" />
      <span className="text-sm font-medium whitespace-nowrap" data-id="element-174">{label}</span>
      {alert && <div className="absolute right-3 w-2 h-2 rounded-full bg-blue-400" data-id="element-175" />}
    </Link>;
};
// Kenar çubuğu (Sidebar) ana bileşeni
export function SidebarFloating() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  // Close mobile menu on route change
  useEffect(() => {
    setMobileOpen(false);
  }, [location]);
  // Mobile menu overlay
  const MobileMenu = () => <div className="fixed inset-0 bg-black/80 z-50 md:hidden" data-id="element-176">
      <div className="w-72 h-full p-4" data-id="element-177">
        <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600 w-full h-full" data-id="element-178">
          <div className="relative isolate overflow-hidden bg-[#0D1117]/95 backdrop-blur-md rounded-xl h-full flex flex-col" data-id="element-179">
            {/* Refined Aurora Effect with subtle color stains */}
            <div className="absolute -top-40 -right-40 -z-10 h-[250px] w-[250px] rounded-full bg-gradient-radial from-purple-900/20 to-transparent blur-3xl" aria-hidden="true" data-id="element-180"></div>
            <div className="absolute -bottom-20 -left-20 -z-10 h-[200px] w-[200px] rounded-full bg-gradient-radial from-blue-900/15 to-transparent blur-3xl" style={{
            animationDelay: '1s'
          }} aria-hidden="true" data-id="element-181"></div>
            <div className="flex justify-between items-center p-4 border-b border-gray-800/40 mb-4 relative z-10" data-id="element-182">
              <h2 className="text-xl font-bold text-white" data-id="element-183">Yönetici Paneli</h2>
              <button onClick={() => setMobileOpen(false)} className="p-1.5 rounded-full bg-purple-500/10 hover:bg-purple-500/20 text-white" data-id="element-184">
                <X size={20} data-id="element-185" />
              </button>
            </div>
            <nav className="h-full flex flex-col relative z-10 p-4" data-id="element-186">
              <div className="flex-1 space-y-2" data-id="element-187">
                {menuItemsAdmin.map(item => <NavItem key={item.label} icon={item.icon} label={item.label} path={item.path} alert={item.alert} data-id="element-188" />)}
              </div>
              <button onClick={() => navigate('/')} className="flex w-full items-center gap-3 px-4 py-3 mt-6 text-left rounded-lg hover:bg-red-500/10 text-red-400 transition-colors" data-id="element-189">
                <LogOut className="w-5 h-5" data-id="element-190" />
                <span data-id="element-191">Çıkış Yap</span>
              </button>
            </nav>
          </div>
        </div>
      </div>
    </div>;
  // Hamburger menu for mobile
  const HamburgerButton = () => <button onClick={() => setMobileOpen(true)} className="md:hidden fixed top-4 left-4 z-40 p-2 rounded-full bg-purple-500/10 text-white" data-id="element-192">
      <Menu size={24} data-id="element-193" />
    </button>;
  return <>
      {/* Mobile hamburger button */}
      <HamburgerButton data-id="element-194" />
      {/* Mobile menu overlay */}
      {mobileOpen && <MobileMenu data-id="element-195" />}
      {/* Desktop/Tablet Sidebar */}
      <aside className="hidden md:block w-64 min-w-[250px] shrink-0" data-id="element-196">
        <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600 h-full" data-id="element-197">
          <div className="relative isolate overflow-hidden bg-black/95 backdrop-blur-md rounded-xl h-full flex flex-col" data-id="element-198">
            {/* Refined Aurora Effect with subtle color stains */}
            <div className="absolute -top-40 -right-40 -z-10 h-[250px] w-[250px] rounded-full bg-gradient-radial from-purple-900/20 to-transparent blur-3xl" aria-hidden="true" data-id="element-199"></div>
            <div className="absolute -bottom-20 -left-20 -z-10 h-[200px] w-[200px] rounded-full bg-gradient-radial from-blue-900/15 to-transparent blur-3xl" style={{
            animationDelay: '1s'
          }} aria-hidden="true" data-id="element-200"></div>
            <div className="absolute top-1/3 right-1/4 -z-10 h-[100px] w-[100px] rounded-full bg-gradient-radial from-pink-900/10 to-transparent blur-3xl" style={{
            animationDelay: '2s'
          }} aria-hidden="true" data-id="element-201"></div>
            <div className="absolute bottom-1/3 right-1/3 -z-10 h-[150px] w-[150px] rounded-full bg-gradient-radial from-indigo-900/15 to-transparent blur-3xl" style={{
            animationDelay: '1.5s'
          }} aria-hidden="true" data-id="element-202"></div>
            {/* Title at the top */}
            <div className="p-5 border-b border-gray-800/40 relative z-10" data-id="element-203">
              <div className="text-xl font-bold text-white" data-id="element-204">
                Yönetici Paneli
              </div>
            </div>
            <nav className="h-full flex flex-col relative z-10 p-4 pt-6 overflow-y-auto" data-id="element-205">
              {/* Navigation Links */}
              <div className="flex-1 space-y-2" data-id="element-206">
                {menuItemsAdmin.map(item => <NavItem key={item.label} icon={item.icon} label={item.label} path={item.path} alert={item.alert} data-id="element-207" />)}
              </div>
              {/* Profile and Logout */}
              <div className="mt-6 pt-4 border-t border-gray-800/40" data-id="element-208">
                <div className="p-3 rounded-lg bg-white/5 border border-purple-500/20 hover:border-purple-500/40 transition-colors mb-4" data-id="element-209">
                  <div className="flex items-center gap-4" data-id="element-210">
                    <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=80&h=80&fit=crop&crop=faces" alt="Yönetici" className="w-10 h-10 rounded-full" data-id="element-211" />
                    <div data-id="element-212">
                      <p className="font-semibold text-white" data-id="element-213">Ahmet Bey</p>
                      <p className="text-xs text-gray-400" data-id="element-214">Kurum Yöneticisi</p>
                    </div>
                  </div>
                </div>
                <button onClick={() => navigate('/')} className="flex w-full items-center gap-3 px-4 py-3 text-left rounded-lg hover:bg-red-500/10 text-red-400 transition-colors" data-id="element-215">
                  <LogOut className="w-5 h-5" data-id="element-216" />
                  <span data-id="element-217">Çıkış Yap</span>
                </button>
              </div>
            </nav>
          </div>
        </div>
      </aside>
    </>;
}